import * as cheerio from 'cheerio'

export function toThousandFilter(num, delemiter = ',') {
  return (num || 0)
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, delemiter))
}

const convertPost = (listPost, listCategory = null, users = []) => {
  const results = []
  listPost.forEach(async (post) => {
    let featuredImage = ''
    try {
      featuredImage = post._embedded['wp:featuredmedia']['0'].source_url
    } catch (error) {}
    if (!featuredImage) {
      const $ = cheerio.load(post.content.rendered)
      const images = $('img').attr('src')
      if (images) {
        featuredImage = images.replace(/-[0-9]+x[0-9]+/g, '')
      }
    }
    const $_ = cheerio.load(post.excerpt.rendered)
    const desc = $_('p').text()
    const $_content = cheerio.load(post.content.rendered)
    const readingTime = $_content('.rt-reading-time .rt-time').text() || ''
    const readingUnit = $_content('.rt-reading-time .rt-label.rt-postfix').text() || ''
    results.push({
      ...post,
      category: listCategory ? listCategory.find((item) => item.id === post.categories[0]) : {},
      featured_image: featuredImage,
      user: users.find((author) => author.id === post.author) || null,
      desc,
      readingTime,
      readingUnit: readingUnit === 'minutes' ? 'min' : readingUnit,
    })
  })
  return results
}

export { convertPost }
export const ParsePasswordGeneratorTitle = (slug, currentApp = null) => {
  if (currentApp && slug.includes('app-')) {
    return `Công cụ tạo mật khẩu mạnh ngẫu nhiên cho ${currentApp.Name[0]}`
  }
  switch (true) {
    case slug.includes('characters'):
      const numOfCharacters = parseInt(slug.split('-')[0])
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên ${numOfCharacters} ký tự`

    case slug === 'with-symbols':
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên bao gồm ký tự đặc biệt`

    case slug === 'alphanumeric':
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên chỉ sử dụng chữ cái và số`

    case slug === 'with-uppercase':
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên chỉ có chữ cái in hoa`

    case slug === 'with-lowercase':
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên chỉ có chữ cái thường`

    case slug === 'mixed-case':
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên kết hợp chữ cái hoa và thường`

    case slug === 'pin-code':
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên dạng mã PIN`

    case slug === 'brute-force-resistance':
      return `Công cụ tạo mật khẩu mạnh ngẫu nhiên kết hợp chữ cái hoa, thường và số`

    case slug === 'memorable':
      return `Công cụ tạo mật khẩu mạnh dễ nhớ kết hợp chữ cái và số`

    default:
      return 'Công cụ tạo mật khẩu mạnh ngẫu nhiên'
  }
}

export const ParsePasswordScoreText = (score) => {
  if (score === 4) {
    return 'Strong Password'
  }
  if (score === 3) {
    return 'Medium Password'
  }
  if (score === 2) {
    return 'Weak Password'
  }
  return 'Weak Password'
}

export function generateCharacterList(min, max) {
  const listCharacter = []

  for (let i = min; i <= max; i++) {
    listCharacter.push({
      slug: `${i}-characters`,
      title: `Mật khẩu ${i} ký tự`,
    })
  }

  return listCharacter
}
